<section class="mod-page assistant-page" data-module="assistant">
  <header class="page-header">
    <div>
      <p class="eyebrow">Case Assistant</p>
      <h1>Ask AI</h1>
    </div>
    <div class="btn-row">
      @if (widget.scopedCaseId()) {
        <span class="scope-pill">
          This case
          <button type="button" (click)="widget.clearScope()" aria-label="Search all cases instead">Clear</button>
        </span>
      } @else {
        <span class="scope-pill muted">All confirmed cases</span>
      }
      <button type="button" class="btn" (click)="widget.clearChat()">Clear chat</button>
    </div>
  </header>

  <div class="assistant-body" #scrollBody>
    @if (widget.messages().length === 1 && !widget.asking()) {
      <div class="welcome">
        <span class="welcome-mark" aria-hidden="true">
          <img class="welcome-bot" src="/svayam-bot.png" alt="" />
        </span>
        <h2>{{ widget.messages()[0].text }}</h2>
        <p class="muted">Ask in plain English or Hindi — names, villages, tehsils, or a topic all work.</p>
        <div class="welcome-suggestions">
          @for (s of widget.suggestions(); track s) {
            <button type="button" class="suggestion-chip" (click)="widget.ask(s)">
              <span>{{ s }}</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
            </button>
          }
        </div>
      </div>
    } @else {
      <div class="message-list" aria-live="polite">
        @for (message of widget.messages(); track message.id) {
          <div class="message-row" [class.user]="message.role === 'user'">
            <div class="avatar" aria-hidden="true">
              @if (message.role === 'assistant') {
                <img class="bot-mark" src="/svayam-bot.png" alt="" />
              } @else {
                You
              }
            </div>
            <div class="message" [class.error]="message.isError">
              @for (line of parseMessageLines(message.text, message.citations); track $index) {
                @if (line.text) {
                  <p>{{ line.text }}</p>
                }
                @if (line.citations.length) {
                  <div class="result-list">
                    @for (c of line.citations; track c.grievanceId) {
                      <a class="result-chip" [routerLink]="['/complaints', c.grievanceId]">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" /></svg>
                        <strong>{{ c.subject || 'Untitled case' }}</strong>
                        <svg class="chip-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
                      </a>
                    }
                  </div>
                }
              }
            </div>
          </div>
        }
        @if (widget.asking()) {
          <div class="message-row">
            <div class="avatar" aria-hidden="true">
              <img class="bot-mark busy" src="/svayam-bot.png" alt="" />
            </div>
            <div class="message">
              <p class="thinking">
                <span class="thinking-dot"></span><span class="thinking-dot"></span><span class="thinking-dot"></span>
              </p>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <form class="composer" (ngSubmit)="widget.ask()">
    <svg class="composer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12 3 1.8 4.4L18 9l-4.2 1.6L12 15l-1.8-4.4L6 9l4.2-1.6L12 3Z"/></svg>
    <input
      #composerInput
      name="question"
      autocomplete="off"
      [ngModel]="widget.query()"
      (ngModelChange)="widget.query.set($event)"
      placeholder="Ask about confirmed cases&hellip;"
      aria-label="Ask about confirmed cases"
      [disabled]="widget.asking()"
    />
    <button type="submit" class="send-btn" [disabled]="!widget.query().trim() || widget.asking()" aria-label="Send">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
    </button>
  </form>
</section>
